<template>
    <div class="row">
        <div class="col-12 col-md-6" v-if="add_or_edit">
            <label class="akkurate-dark small" for="model_id">Receipt No<star></star></label>
            <b-form-group id="model_id" label-for="model_id">
                <b-form-input :disabled="trans_type == 'add'" class="mb-3 mt-2 field-container fields" type="number"
                    placeholder="Enter Receipt" v-model="form.model_id"></b-form-input>
                <errors v-if="errors_msg.model_id">
                    {{ errors_msg.model_id[0] }}
                </errors>
            </b-form-group>
        </div>
        <div class="col-12 col-md-6" v-if="add_or_edit">
            <label class="akkurate-dark small" for="model_type">Model Type<star></star></label>
            <b-form-group id="model_type" label-for="model_type">
                <multiselect id="model_type" name="model_type" class="mt-2 field-container" v-model="form.model_type"
                    :options="model_options" track-by="id" label="name">
                </multiselect>
                <errors v-if="errors_msg.model_type">
                    {{ errors_msg.model_type[0] }}
                </errors>
            </b-form-group>
        </div>
        <div class="col-12 col-md-6">
            <label class="akkurate-dark small" for="debit">Debit<star></star></label>
            <b-form-group id="debit" label-for="debit">
                <b-form-input class="mb-3 mt-2 field-container fields" type="text" placeholder="Enter Debit"
                    v-model="form.dr_amount"></b-form-input>
                <errors v-if="errors_msg.debit">
                    {{ errors_msg.debit[0] }}
                </errors>
            </b-form-group>
        </div>
        <div class="col-12 col-md-6">
            <label class="akkurate-dark small" for="credit">Credit<star></star></label>
            <b-form-group id="credit" label-for="credit">
                <b-form-input class="mb-3 mt-2 field-container fields" type="text" placeholder="Enter Credit"
                    v-model="form.cr_amount"></b-form-input>
                <errors v-if="errors_msg.credit">
                    {{ errors_msg.credit[0] }}
                </errors>
            </b-form-group>
        </div>
        <div class="col-12 col-md-6">
            <label class="akkurate-dark small" for="coa_subhead_id">Chart of Account</label>
            <b-form-group id="coa_subhead_id" name="coa_subhead_id" label-for="coa">
                <multiselect id="coa_subhead_id" name="coa_subhead_id" class="mt-2 field-container" label="name"
                    v-model="form.coa_subhead_id" :options="coa_subhead_options" :custom-label="coaSelectLabel"
                    track-by="id">
                </multiselect>
            </b-form-group>
            <!-- <b-form-invalid-feedback>
                {{ veeErrors.first('coa_subhead_id') }}
            </b-form-invalid-feedback> -->
            <errors v-if="errors_msg.coa_subhead_id">
                {{ errors_msg.coa_subhead_id }}
            </errors>
        </div>
        <div class="col-12 col-md-6">
            <b-form-group label-for="transaction_description" class="mb-2">
                <template #label>
                    <label class="akkurate-dark small" for="transaction_description">Transaction Description</label>
                </template>
                <b-form-input class="mb-3 mt-2 field-container fields" type="text"
                    placeholder="Enter Transaction Description" v-model="form.transaction_description"></b-form-input>
            </b-form-group>
            <errors v-if="errors_msg.transaction_description">
                {{ errors_msg.transaction_description[0] }}
            </errors>
        </div>
        <div class="col-12 col-md-6">
            <b-form-group label-for="transaction_date" class="mb-2">
                <template #label>
                    <label class="akkurate-dark small" for="transaction_date">Transaction Date</label>
                </template>
                <b-form-input class="mb-3 mt-2 field-container fields" type="date"
                    placeholder="Enter Transaction Date" v-model="form.transaction_date" required></b-form-input>
            </b-form-group>
            <errors v-if="errors_msg.transaction_date">
                {{ errors_msg.transaction_date[0] }}
            </errors>
        </div>
    </div>
</template>

<script>
import Multiselect from "vue-multiselect";

export default {
    components: {
        Multiselect,
    },
    data() {
        return {
            isLoading: false,
            errors_msg: {},
            coa_subhead: {},
            isSaving: false,
           
        }
    },
    props: {
        form: {
            required: true
        },
        coa_subhead_options: {
            required: true
        },
        add_or_edit: {
            require: true
        },
        model_options:{
            require: false,
        },
        trans_type:{
            require: false
        }
    },
    methods: {
         getDisabled(){
            console.log(this.form.model_id);
            if(this.form.model_id == ""){
                return false
            }else{
                return true
            }
        },
        coaSelectLabel({ id, name, code, coabranch }) {
            let select_label = `${code ? code : ""} - ${name}`
            if (coabranch) {
                select_label += `- ${coabranch.name}`
            }
            return select_label;
        },
    }

}
</script>